module.exports = __webpack_public_path__ + "CHERY-logo.png";